<div class="container mx-auto max-h-full">
  <fl-fo-header></fl-fo-header>
  <main class="bg-white flex-col flex w-full">
    <p-confirmdialog />
    @if (isAuthenticated()) {
      <p-breadcrumb [model]="breadcrumbItems()"></p-breadcrumb>
    }
    <router-outlet></router-outlet>
    <p-toast>
      <ng-template let-message #message>
        <span
          class="p-toast-message-icon pi"
          [class]="{
            'pi-info-circle': message.severity === 'info',
            'pi-exclamation-triangle': message.severity === 'warn',
            'pi-times-circle': message.severity === 'error',
            'pi-check': message.severity === 'success',
          }">
        </span>
        <div class="p-toast-message-text">
          @if (message.summary) {
            <div class="p-toast-summary">{{ message.summary }}</div>
          }
          <div class="p-toast-detail" [innerHTML]="message.detail"></div>
        </div>
      </ng-template>
    </p-toast>
  </main>
  <footer class="bg-gray-700 text-gray-300 py-8 px-6 md:px-12">
    <div class="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
      <div>
        <img src="assets/images/logo-footer.png" alt="Fare Lazio White Logo" class="h-12 mb-4" />
        <p class="text-sm">
          Dal 1 gennaio 2025 è efficace la fusione per incorporazione di Banca Agevolarti S.P.A (già Artigiancassa
          S.p.A.) in Banca Nazionale del Lavoro S.p.A. Pertanto all’interno del sito, ogni eventuale riferimento ad
          Artigiancassa S.p.A. o Banca Agevolarti S.p.a. è da intendersi automaticamente sostituito dal riferimento a
          BNL S.p.A.
        </p>
      </div>
      <div>
        <h4 class="text-lg font-semibold text-white mb-4">Link Utili</h4>
        <ul class="space-y-2 text-sm">
          <li><a href="#" class="hover:text-white">Privacy Policy</a></li>
          <li><a href="#" class="hover:text-white">Cookie Policy</a></li>
          <li><a href="#" class="hover:text-white">Condizioni d'uso</a></li>
          <li><a href="#" class="hover:text-white">Accessibilità</a></li>
        </ul>
      </div>
      <div>
        <h4 class="text-lg font-semibold text-white mb-4">Contatti</h4>
        <p class="text-sm">Viale Altiero Spinelli, 30<br />00157 Roma (RM), Italia</p>
        <p class="text-sm mt-2">Email: info&#64;farelazio.it</p>
        <p class="text-sm">Tel: +39 06 47021</p>
      </div>
    </div>
    <div class="text-center text-sm border-t border-gray-700 pt-6 mt-8">
      2025 &copy; fareLAZIO (RTI tra Banca Nazionale del Lavoro S.p.A., MedioCredito Centrale S.p.A.) - Tutti i diritti
      riservati.
    </div>
  </footer>
</div>
